export const stringReplace = (input = "", replace = {}) =>
  Object.keys(replace).reduce((acc, key) => acc.replace(`{${key}}`, replace[key]), input);
export default stringReplace;
